import { render, staticRenderFns } from "./ClassFavoriteList.vue?vue&type=template&id=826a7bf8&"
import script from "./ClassFavoriteList.vue?vue&type=script&lang=js&"
export * from "./ClassFavoriteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports